import React from 'react'

const ListPartner = ({ partnerlist, totalCount, currentPage, totalPages, onPageChange }) => {
  const startItem = totalCount === 0 ? 0 : ((currentPage - 1) * 10) + 1
  const endItem = totalCount === 0 ? 0 : Math.min(currentPage * 10, totalCount)

  return (
    <div className='overflow-hidden rounded-[24px] border border-slate-200 bg-white shadow-[0_18px_42px_rgba(15,23,42,0.07)]'>
      <div className='flex flex-col gap-3 border-b border-slate-100 bg-[#fffaf6] px-5 py-4 md:flex-row md:items-center md:justify-between'>
        <div>
          <p className='text-xs font-[GilroyBold] uppercase tracking-[0.14em] text-[#f97316]'>Partner records</p>
          <p className='mt-1 text-sm font-[GilroyMedium] text-slate-500'>
            Showing {startItem}-{endItem} of {totalCount}
          </p>
        </div>
        <div className='flex items-center gap-2'>
          <button
            type='button'
            onClick={() => onPageChange(currentPage - 1)}
            disabled={currentPage <= 1}
            className='rounded-full border border-slate-200 px-4 py-2 text-sm font-[GilroyBold] text-slate-600 transition-colors hover:border-[#f97316] hover:bg-[#fff7f2] hover:text-[#f97316] disabled:cursor-not-allowed disabled:opacity-40'
          >
            Previous
          </button>
          <div className='rounded-full bg-[#fff4ed] px-4 py-2 text-sm font-[GilroyBold] text-[#f97316] shadow-[inset_0_0_0_1px_rgba(249,115,22,0.14)]'>
            {currentPage} / {totalPages}
          </div>
          <button
            type='button'
            onClick={() => onPageChange(currentPage + 1)}
            disabled={currentPage >= totalPages}
            className='rounded-full border border-slate-200 px-4 py-2 text-sm font-[GilroyBold] text-slate-600 transition-colors hover:border-[#f97316] hover:bg-[#fff7f2] hover:text-[#f97316] disabled:cursor-not-allowed disabled:opacity-40'
          >
            Next
          </button>
        </div>
      </div>
      <div className='overflow-x-auto'>
        <table className='min-w-full border-separate border-spacing-0'>
          <thead>
            <tr className='bg-[#fffaf6]'>
              <th className='border-b border-slate-200 px-5 py-4 text-left text-xs font-[GilroyBold] uppercase tracking-[0.14em] text-[#bf7b52]'>LR No</th>
              <th className='border-b border-slate-200 px-5 py-4 text-left text-xs font-[GilroyBold] uppercase tracking-[0.14em] text-[#bf7b52]'>Partner Name</th>
              <th className='border-b border-slate-200 px-5 py-4 text-left text-xs font-[GilroyBold] uppercase tracking-[0.14em] text-[#bf7b52]'>Forwarding Number</th>
            </tr>
          </thead>
          <tbody>
            {partnerlist?.length ? partnerlist.map((item) => (
              <tr key={item.id || item.lrno} className='transition-colors hover:bg-slate-50/70'>
                <td className='border-b border-slate-100 px-5 py-4 text-[13px] font-[GilroyBold] text-slate-900'>{item.lrno || '-'}</td>
                <td className='border-b border-slate-100 px-5 py-4 text-[13px] font-[GilroyMedium] text-slate-700'>{item.partner || '-'}</td>
                <td className='border-b border-slate-100 px-5 py-4 text-[13px] font-[GilroyMedium] text-slate-700'>
                  {item.partner === "GRC" ? item.lrno : (item.forwardingNumber || '-')}
                </td>
              </tr>
            )) : (
              <tr>
                <td colSpan={3} className='px-5 py-16 text-center'>
                  <p className='text-base font-[GilroyMedium] text-slate-500'>No partner records found</p>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  )
}

export default ListPartner
